import Axios from "axios";
import React, { useEffect, useState } from "react";
import CityReg from "./CityReg";

const LiveWire = () => {
    const [livewireReg, setLivewireReg] = useState([]);

    const cities = ["Shillong", "Banglore", "Delhi", "Mumbai"];

    const getLivewireReg = () => {
        Axios.post(
            "https://jarvis.moodi.org/livewire/get_reg",
            {
                cookies: "ShubhamRandi",
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        )
            .then((res) => setLivewireReg(res.data))
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        getLivewireReg();
    }, []);
    return (
        <div className="container-fluid">
            <h2>Livewire Registrations (Total reg - {livewireReg.length})</h2>
            <div class="accordion" id="accordionExample">
                {cities.map((city) => {
                    let cityReg = livewireReg.filter(
                        (element) => element.city === city
                    );
                    return (
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button
                                    class="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#${city}`}
                                    aria-expanded="false"
                                    aria-controls="collapseTwo"
                                >
                                    {city} ({cityReg.length})
                                </button>
                            </h2>
                            <div
                                id={city}
                                class="accordion-collapse collapse"
                                data-bs-parent="#accordionExample"
                            >
                                <div class="accordion-body">
                                    <CityReg cityReg={cityReg} />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            {/* {cities.map((city) => {
                let cityReg = livewireReg.filter(
                    (element) => element.city === city
                );
                return <CityReg city={city} cityReg={cityReg} />;
            })} */}
        </div>
    );
};

export default LiveWire;
